/* node_modules */
import React from 'react';
import {
  Routes, Route, Link, useLocation,
} from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

/* local imports */
import FormattedMessage from '~/components/common/FormattedMessage';
import LoginScreen from './LoginScreen';
import PasswordReset from './PasswordReset';
import ResendConfirmation from './ResendConfirmation';

/* style imports */
import styles from './Login.scss';

// I just structure my imports in three sections, within those sections the most
// important items are usually at the very top.

// This is a view in itself, which is why I would put it in a different file.
// Views are basically the most top-level our components get, so they deserve it.
const Login = () => {
  const location = useLocation();
  const timeout = 300;

  // Using the component prop instead of children reduces the number of characters significantly
  console.log(location.pathname);
  return (
    <div className={styles.Login__Container}>
      <TransitionGroup>
        <CSSTransition timeout={timeout} key={location.pathname} classNames={{ exit: styles.SlideOut }}>
          <Routes>
            <Route path="">
              <Route index element={<LoginScreen />} />
              <Route path="/reset_password" element={<PasswordReset />} />
              <Route path="/resend_confirmation" element={<ResendConfirmation />} />
            </Route>
          </Routes>
        </CSSTransition>
      </TransitionGroup>
      {location.pathname !== '/login' && (
      <div className={styles.Login__Links}>
        <Link to="/login">
          <FormattedMessage id="BackToLogin" defaultMessage="Back to Login" />
        </Link>
      </div>
      )}
    </div>
  );
};

export default Login;
